module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x2-4707fc18c9d9a80360f0f709878c527d.jpg";